import { IDirective, IScope } from 'angular';
import { $Event } from '../../../helpers';

interface IGmcFilereaderScope extends IScope {
  gmcFilereader: ( $event ) => void;
}

export function gmcFilereaderDirective(): IDirective {
  return {
    restrict: 'A',
    scope: {
      gmcFilereader: '&'
    },
    link: function postLink( scope: IGmcFilereaderScope, element ) {
      element.on('change', ( event: any ) => {
        scope.$apply(() => {
          scope.gmcFilereader(new $Event({ files: event.target.files }));
        });
      });
    }
  };
}

gmcFilereaderDirective.$inject = [];



// WEBPACK FOOTER //
// ./app/shared/directives/gmc-filereader/gmc-filereader.directive.ts